import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const getCourseLayoutIdOnRoundAtom = atom((get) => {
  const selectedRound = get(selectedRoundAtom);
  return selectedRound?.courseLayoutId || "";
});
